import PropTypes from 'prop-types';
import React from 'react';

import { Button } from '../../../components';
import { REFUND_TYPE } from '../../../config';
import { DetailRow } from './detail-row';
import { amountByCurrency, crypto, rateDisplay } from './refund-format';

const hasValue = (value) => value !== undefined && value !== null && value !== '';
const firstValue = (...values) => values.find(hasValue);

/** Step 3 (refund branches) — confirm the refund before 2FA. */
const RefundSummaryStep = ({
  dispute,
  refundType,
  preview,
  walletAddress,
  walletNetwork,
  onContinue,
  onBack
}) => {
  const isExcess = refundType === REFUND_TYPE.OVERPAYMENT_EXCESS;
  const settlementCurrency = preview?.source_currency;
  // Refund currency === payment currency for dispute refunds; rate is 1 when
  // the preview can't supply one.
  const refundCurrency =
    preview?.payout_currency || dispute?.payment_currency_slug || dispute?.currency_slug;
  const rateCurrency = settlementCurrency || refundCurrency;
  const conversionRate = preview?.conversion_rate ?? 1;
  const refundAmount = isExcess
    ? firstValue(
        preview?.transaction?.payment_amount,
        dispute?.expected_amount,
        dispute?.payment_amount
      )
    : firstValue(
        preview?.transaction?.amount_paid,
        dispute?.actual_amount_paid,
        dispute?.amount_paid
      );
  const customerPayout = firstValue(
    preview?.payout_amount,
    dispute?.refund_amount,
    dispute?.amount
  );
  const txCurrency = refundCurrency || settlementCurrency;

  return (
    <div className="resolve resolve--summary">
      <div className="resolve__rows resolve__rows--bordered">
        <DetailRow
          label="REFUND TYPE"
          testId="summary-refund-type"
          value={isExcess ? 'Excess refund' : 'Full refund'}
        />
        <DetailRow label="REFUND AMOUNT" value={amountByCurrency(refundAmount, txCurrency)} />
        <DetailRow
          label="CUSTOMER PAYOUT"
          testId="summary-customer-payout"
          value={crypto(customerPayout, refundCurrency)}
        />
        <DetailRow
          label="CONVERSION RATE"
          value={rateDisplay(refundCurrency, conversionRate, rateCurrency)}
        />
        <DetailRow label="NETWORK" value={walletNetwork || preview?.wallet_network || '--'} />
        <DetailRow label="WALLET ADDRESS" value={walletAddress || preview?.wallet_address} />
        <DetailRow
          label="REFUND CURRENCY"
          info="Currency the customer is refunded in"
          value={(refundCurrency || '').toUpperCase() || '--'}
        />
      </div>

      <div className="resolve__actions">
        <Button variant="outline" type="button" onClick={onBack} data-testid="summary-back-btn">
          Back
        </Button>
        <Button type="button" onClick={onContinue} data-testid="summary-continue-btn">
          Continue
        </Button>
      </div>
    </div>
  );
};

RefundSummaryStep.propTypes = {
  dispute: PropTypes.object,
  refundType: PropTypes.string,
  preview: PropTypes.object,
  walletAddress: PropTypes.string,
  walletNetwork: PropTypes.string,
  onContinue: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired
};

export { RefundSummaryStep };
